/** Pixen Intrigue — English overrides for the auth feature. Courtly-fae voice. */
export const authPixEn = {
  // ── AuthShell ────────────────────────────────────────────────────────────
  'auth.shell.homeAriaLabel': 'Pixen Intrigue home',
  'auth.shell.logoAlt': 'Pixen Intrigue',

  // ── AccountVerifyPage ────────────────────────────────────────────────────
  'auth.verify.seoDescription': 'Verifying your Pixen Intrigue sign-in link.',
  'auth.verify.signedInAsSuffix': '. Taking you back to the Court…',
  'auth.verify.takingYouToSanctum': 'Taking you back to the Court…',

  // ── LoginPage ────────────────────────────────────────────────────────────
  'auth.login.seoTitle': 'Present Yourself at Court',
  'auth.login.seoDescription': 'Sign in to Pixen Intrigue and return to your intrigue in the courts of the fae.',
  'auth.login.eyebrow': 'Return, Courtier',
  'auth.login.title': 'Present Yourself at Court',
  'auth.login.blurb': 'Give your name and the secret word to be admitted once more.',
  'auth.login.noPactYet': 'Not yet presented at Court?',
  'auth.login.forgeYourLegend': 'Join the Court',
  'auth.login.emailPlaceholder': 'you@pixenintrigue.com',
  'auth.login.submitBusy': 'Presenting yourself…',

  // ── RegisterPage ─────────────────────────────────────────────────────────
  'auth.register.errorEmailRequired': 'An email is required to be admitted to Court.',
  'auth.register.errorMustBeAdult': 'You must be 13 or older to join Pixen Intrigue.',
  'auth.register.errorMustAcceptTerms': "You must accept the Court's terms to continue.",
  'auth.register.errorIncomplete': 'Some details of your introduction are incomplete. See below.',
  'auth.register.seoTitle': 'Begin Your Intrigue',
  'auth.register.seoDescription': 'Create a Pixen Intrigue account, don a mask, and let your scheming become canon.',
  'auth.register.eyebrow': 'Enter the Court',
  'auth.register.title': 'Begin Your Intrigue',
  'auth.register.blurb': 'You arrive at the edge of the glamour, mask in hand, and step through…',
  'auth.register.alreadyBound': 'Already known to the Court?',
  'auth.register.displayNamePlaceholder': 'Lady Thistledown',
  'auth.register.emailPlaceholder': 'you@pixenintrigue.com',
  'auth.register.termsOfThePact': 'Terms of the Court',
  'auth.register.submitBusy': 'Sealing your introduction…',
  'auth.register.submit': 'Enter',

  // ── ResetPasswordPage ────────────────────────────────────────────────────
  'auth.reset.errorInvalidEmail': 'Enter the email tied to your account at Court.',
  'auth.reset.blurb':
    "Whisper your email into the glamour and a one-time link will find its way back. Follow it, and you'll set a new password.",
  'auth.reset.successMessage':
    'If an account exists for {email}, a one-time link has been sent. Open it to sign in and set your new password — check your inbox, and the spam thicket.',
  'auth.reset.emailPlaceholder': 'you@pixenintrigue.com',

  // ── SetPasswordPage ──────────────────────────────────────────────────────
  'auth.setPassword.seoDescription': 'Choose a new password for your Pixen Intrigue account.',
  'auth.setPassword.eyebrow': 'Seal Your Word',
  'auth.setPassword.successMessage': 'Your password is set. Taking you back to the Court…',
}
